import { Component, Input, OnInit } from '@angular/core';
import { CommonDataService } from '../../../common/services/common-data.service';
import { GraphqlService } from '../../../common/services/graphql.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-help-browsing',
  templateUrl: './help-browsing.component.html'
})
export class HelpBrowsingComponent implements OnInit {

  // IsRightPanel:boolean;
  @Input() IsRightPanel:boolean=false;
  constructor(public commonDataService: CommonDataService,
    private graphQlService: GraphqlService, private route: Router) {

  }

  ngOnInit(): void {
    // this.IsRightPanel=this.commonDataService.showRightPanel.getValue();
    window.scrollTo(0, 0);
   
    this.commonDataService.showLoader.next(true);
    this.gethelpbrowsinglabels();
  }
  browsing_header;
  browsing_desc;
  browsing_para1heading;
  browsing_para1body;
  gethelpbrowsinglabels() {

    this.graphQlService.gethelpbrowsingLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.browsing_header = labels.filter(x => x.key == "browsing_header").map(y => y.value);
        this.browsing_desc = labels.filter(x => x.key == "browsing_desc").map(y => y.value);
        this.browsing_para1heading = labels.filter(x => x.key == "browsing_para1heading").map(y => y.value);
        this.browsing_para1body = labels.filter(x => x.key == "browsing_para1body").map(y => y.value);
        this.commonDataService.showLoader.next(false);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });

  }
}
